<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>{{ $route.meta.name }}管理</el-breadcrumb-item>
      <el-breadcrumb-item>角色列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <el-page-header @back="$router.go(-1)" content="权限管理">
      </el-page-header>
      <form @submit.prevent="handleAuthUpdate">
        <div class="tab-content m-t-20">
          <!--SHOWING ERRORS IN TOOLTIP-->
          <!--===================================================-->
          <div id="tabs-box-1" class="tab-pane fade in active">
            <div class="row">
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label">选择角色</label>
                    <select
                      class="role selectpicker form-control"
                      data-live-search="true"
                      data-width="100%"
                    >
                      <option value="0">请选择角色</option>
                      <option
                        :value="item.id"
                        v-for="item in roles"
                        :selected="item.id == $route.params.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-12 mar-top">
                  <div class="form-group">
                    <label class="control-label">选择模块</label>
                    <div class="col-md-12 pad-no">
                      <div class="checkbox">
                        <!-- Inline Checkboxes -->
                        <template v-for="item in function_modules">
                          <input
                            :id="'checkbox' + item.id"
                            :value="item.id"
                            class="magic-checkbox hide"
                            type="radio"
                            v-model="selected_role.function_module_id"
                          />
                          <label :for="'checkbox' + item.id">{{
                            item.name
                          }}</label>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-12">
                <div
                  class="tab-base auth col-sm-12"
                  v-show="Object.keys(functions).length > 0"
                >
                  <ul class="nav nav-tabs">
                    <template v-for="(v, k, index) in functions">
                      <li
                        :class="{ active: index == 0 }"
                        v-for="item in v"
                        v-if="item.father_id == 0"
                      >
                        <a
                          data-toggle="tab"
                          class="module-a"
                          :href="'#role-module-' + k"
                          >{{ item.name }}</a
                        >
                      </li>
                    </template>
                  </ul>

                  <div class="tab-content">
                    <template v-for="(v, k, index) in functions">
                      <div
                        :id="'role-module-' + k"
                        class="tab-pane fade"
                        :class="{ 'active in': index == 0 }"
                      >
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <template v-for="fun in v">
                                <template v-if="fun.father_id == 0">
                                  <label class="control-label">
                                    <span @click="checkAll(fun, v)">全选</span>
                                  </label>
                                  <div class="checkbox auth">
                                    <input
                                      :value="fun.id"
                                      :id="'role-auth-checkbox-' + fun.id"
                                      :class="
                                        'role-all-box-' +
                                        fun.id +
                                        ' ' +
                                        'role-check-box-' +
                                        fun.id
                                      "
                                      class="magic-checkbox"
                                      type="checkbox"
                                    />
                                    <template v-for="func in v">
                                      <template v-if="func.father_id == fun.id">
                                        <input
                                          :id="'role-auth-checkbox-' + func.id"
                                          class="magic-checkbox"
                                          type="checkbox"
                                          :value="func.id"
                                          v-model="selected_role.auths"
                                        />
                                        <label
                                          :for="'role-auth-checkbox-' + func.id"
                                          @click="selectFun(func)"
                                          >{{ func.name }}</label
                                        >
                                      </template>
                                    </template>
                                  </div>
                                </template>
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer clearfix">
          <div class="col-sm-12">
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="
                selected_role.role_id == 0 ||
                selected_role.function_module_id == 0
              "
            >
              保存
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {
  roleList,
  authList,
  roleAuthList,
  roleAuthUpdate,
  getFunctionModules,
} from '@/service/getData'

export default {
  data() {
    return {
      selected_role: {
        role_id: parseInt(this.$route.params.id),
        function_module_id: 0,
        auths: [],
      },
      roles: [],
      function_modules: [],
      functions: {},
    }
  },
  watch: {
    'selected_role.role_id': 'getRoleAuth',
    'selected_role.function_module_id': 'getRoleAuth',
  },
  mounted() {
    let that = this
    this.$nextTick(() => {
      $('.role.selectpicker')
        .chosen()
        .change(function () {
          that.selected_role.role_id = parseInt($(this).val())
        })

      // $(".module.selectpicker").chosen().change(function(){
      // 	that.selected_role.function_module_id = parseInt($(this).val())
      // });
    })
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      let res = await roleList()
      this.roles = res.data

      res = await getFunctionModules()
      this.function_modules = res.data
      this.selected_role.function_module_id = this.function_modules[0].id

      this.$nextTick(() => {
        $('.selectpicker').trigger('chosen:updated')
      })

      // res = await authList()

      // let data = {}
      // res.data.map(item => {
      // 	if (!data[item.module_id]){
      // 		data[item.module_id] = []
      // 	}
      // 	data[item.module_id].push(item)
      // })
      // this.functions = data
    },
    async getRoleAuth() {
      if (
        this.selected_role.role_id == 0 ||
        this.selected_role.function_module_id == 0
      ) {
        this.selected_role.auths = []
        this.functions = {}
      }

      if (
        this.selected_role.role_id > 0 ||
        this.selected_role.function_module_id > 0
      ) {
        let res = await roleAuthList({
          role_id: this.selected_role.role_id,
          function_module_id: this.selected_role.function_module_id,
        })
        if (res.status != 0) return false

        this.selected_role.auths = res.data
          .filter((item) => item.selected == true)
          .map((item) => {
            return item.id
          })

        let data = {}
        res.data.map((item) => {
          if (!data[item.module_id]) {
            data[item.module_id] = []
          }
          data[item.module_id].push(item)
        })
        this.functions = data
      }
    },
    checkAll(fun, v) {
      if (fun.select_all) {
        v.map((item) => {
          let index = this.selected_role.auths.indexOf(item.id)
          if (index > -1) {
            this.selected_role.auths.splice(index, 1)
          }
        })
        fun.select_all = false
      } else {
        v.map((item) => {
          let index = this.selected_role.auths.indexOf(item.id)
          if (index == -1) {
            this.selected_role.auths.push(item.id)
          }
        })
        fun.select_all = true
      }
    },
    selectFun(func) {
      if (this.selected_role.auths.indexOf(func.id) != -1) {
        //取消选中
        let module_arr = []
        this.functions[func.module_id].map((item) => {
          if (item.father_id > 0 && item.id != func.id) {
            module_arr.push(item.id)
          }
        })
        let a = this.selected_role.auths
        var c = module_arr.filter(function (v) {
          return a.indexOf(v) > -1
        })

        if (c.length == 0) {
          let index = a.indexOf(func.father_id)
          if (index > -1) {
            this.selected_role.auths.splice(index, 1)
          }
        }
      } else {
        if (this.selected_role.auths.indexOf(func.father_id) == -1) {
          this.selected_role.auths.push(func.father_id)
        }
      }
    },
    async handleAuthUpdate() {
      if (this.selected_role.role_id == 0) {
        alert('请选择角色')
        return
      }
      if (this.selected_role.function_module_id == 0) {
        alert('请选择模块')
        return
      }

      let res = await roleAuthUpdate(this.selected_role)
      if (res.status == 0) {
        this.$message({
          message: '保存成功！',
          type: 'success',
        })
      }
    },
  },
}
</script>